import * as React from "react";
const SvgFiRrSpoon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-spoon_svg__a)">
      <path
        fill="#062147"
        d="M22.918 1.082c-2.58-2.58-8.743-.04-11.1 2.316a6.2 6.2 0 0 0-.635 8L.293 22.292a1 1 0 1 0 1.415 1.414L12.6 12.816a6.18 6.18 0 0 0 8-.635c2.358-2.357 4.9-8.52 2.318-11.1m-3.73 9.685C15.16 14.59 9.41 8.84 13.233 4.812 14.91 3.28 19.283.956 21.5 2.5c1.45 1.443-.461 6.415-2.312 8.267"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-spoon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSpoon;
